export { DeckLinkedNoteTag, DeckLinkedNoteTagProps } from './DeckLinkedNoteTag';
